module.exports = __webpack_public_path__ + "img/toki.ec7970e9.webp";